"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _canUseDom = _interopRequireDefault(require("can-use-dom"));
var _Facebook = _interopRequireDefault(require("./Facebook"));
var _FacebookContext = _interopRequireDefault(require("./FacebookContext"));
var api = null;
var Facebook = /*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Facebook, _Component);
  function Facebook() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isReady: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInit", function _callee() {
      var isReady, _this$props, domain, version, appId, cookie, status, xfbml, language, frictionlessRequests, wait, debug, chatSupport;
      return _regenerator.default.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_canUseDom.default) {
                _context.next = 2;
                break;
              }
              throw new Error('You can not use Facebook without DOM');
            case 2:
              isReady = _this.state.isReady;
              if (!isReady) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", api);
            case 5:
              if (!api) {
                _this$props = _this.props, domain = _this$props.domain, version = _this$props.version, appId = _this$props.appId, cookie = _this$props.cookie, status = _this$props.status, xfbml = _this$props.xfbml, language = _this$props.language, frictionlessRequests = _this$props.frictionlessRequests, wait = _this$props.wait, debug = _this$props.debug, chatSupport = _this$props.chatSupport;
                api = new _Facebook.default({
                  domain: domain,
                  appId: appId,
                  version: version,
                  cookie: cookie,
                  status: status,
                  xfbml: xfbml,
                  language: language,
                  frictionlessRequests: frictionlessRequests,
                  wait: wait,
                  debug: debug,
                  chatSupport: chatSupport
                });
              }
              _context.next = 8;
              return _regenerator.default.awrap(api.init());
            case 8:
              if (!_this.state.isReady) {
                _this.setState({
                  isReady: true
                });
              }
              return _context.abrupt("return", api);
            case 10:
            case "end":
              return _context.stop();
          }
        }
      });
    });
    return _this;
  }
  var _proto = Facebook.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var wait = this.props.wait;
    if (!wait) {
      this.handleInit();
    }
  };
  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
      isReady = _this$state.isReady,
      error = _this$state.error;
    var handleInit = this.handleInit;
    var value = {
      isReady: isReady,
      error: error,
      handleInit: handleInit,
      api: api
    };
    return _react.default.createElement(_FacebookContext.default.Provider, {
      value: value
    }, children);
  };
  return Facebook;
}(_react.Component);
exports.default = Facebook;
(0, _defineProperty2.default)(Facebook, "defaultProps", {
  version: 'v3.1',
  cookie: false,
  status: false,
  xfbml: false,
  language: 'en_US',
  frictionlessRequests: false,
  domain: 'connect.facebook.net',
  children: undefined,
  wait: false,
  debug: false,
  chatSupport: false
});